import AppError from 'util/AppError';
import axios from "axios";


class TigerSharkRestSystem {
  framework;
  

  constructor(_framework) {
    this.framework = _framework;
  }

  getFramework() {
    return this.framework;
  }  

  async manageResponse(response) {
    console.log("manageResponse being executed");
    if(response !== null && response !== undefined) {
      console.log(response.status);
      if(response.status === 200) {
        return response;
      }
      else {             
        const restException = await response.json();
        if(restException.exceptionType !== undefined) {
          throw new AppError(restException.httpSystemUserType,restException.messge,restException.developerMessage,restException.code,restException.exceptionType);
        }
        else if(response.status === 400) {
          throw new AppError("Bad Request [400]","Bad Request","No stackTrace","rest_system-2005","BadRequestException");
        }
        else if(response.status === 403) {
          throw new AppError("Forbidden [403]","Forbidden","No stackTrace","rest_system-2007","BadRequestException");
        } 
        else if(response.status === 500) {
          console.log("response::::");
          console.log(response);
          let json = await response.json();
          console.log("json::::");
          console.log(json);
          throw new AppError(json.localizedMessage +"["+json.httpStatus+"]",json.message,json.developerMessage,json.code,json.exceptionType);
        }         
        else {
          console.log(restException);
          throw new AppError("Unknown Error [403]","Unknown Error","No stackTrace","rest_system-2001","UnknownException");
        } 
      }
    }
    throw new AppError("Invalid Response Error [403]","Invalid Response Error","No stackTrace","rest_system-2003","InvalidResponseException");
  }

  manageError(error) {    
    if(error.response !== null && error.response !== undefined) {
      if(error.response.data !== null && error.response.data !== undefined) {
        if(error.response.data.exceptionType !== null && error.response.data.exceptionType !== undefined) {
          let errorData = error.response.data;
          throw new AppError("["+errorData.httpStatus+"]",errorData.message,errorData.developerMessage,errorData.code,errorData.exceptionType);
        }
      }
    }
    throw new AppError("Fetch Exception [500]:" + error,error,"StackTrace:\n" + error,"rest_system-2031","RestException");
  }

  async manageAuthenticateResponse(response) {
    if(response !== null && response !== undefined) {
      if(response.status === 200) {
        return response;
      }
      else {                     
        if(response.status === 400) {
          throw new AppError("Bad Request [400]","Bad Request","No stackTrace","rest_system-2005","BadRequestException");
        }
        else if(response.status === 403) {
          throw new AppError("Forbidden [403]","Forbidden","No stackTrace","rest_system-2007","BadRequestException");
        } 
        else if(response.status === 500) {
          console.log("response::::");
          console.log(response);
          let json = await response.json();
          console.log("json::::");
          console.log(json);
          throw new AppError(json.localizedMessage +"["+json.httpStatus+"]",json.message,json.developerMessage,json.code,json.exceptionType);
        }                
        else {
          throw new AppError("Unknown Error [403]","Unknown Error","No stackTrace","rest_system-2001","UnknownException");
        } 
      }
    }
    throw new AppError("Invalid Response Error [403]","Invalid Response Error","No stackTrace","rest_system-2003","InvalidResponseException");
  }   

  async apiFetch(url) {
    const headers = {
      method: 'GET', 
      mode: 'cors', 
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      origin: this.framework.getMemorySystem().getOrigin() ,
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    };
    const response = await axios.get(url, headers)
    .catch(error => {
      throw this.manageError(error);
    });
    return await this.manageResponse(response);
  }

  
  async apiPost(url,data ={}) {
    const headers = {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      origin: this.framework.getMemorySystem().getOrigin(),
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
    };
    const response = await axios.post(url,data,headers)
    .catch(error => {
      throw this.manageError(error);
    });
    return await this.manageResponse(response);
  } 

  async apiFetchWithAccessToken(url,accessToken) {
    let headers = {
      method: 'GET', 
      mode: 'cors', 
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessToken,
      },
      origin: this.framework.getMemorySystem().getOrigin() ,
      redirect: 'follow',
      referrerPolicy: 'no-referrer'
    };
    const response = await axios.get(url,headers)
    .catch(error => {
      throw this.manageError(error);
    });
    return await this.manageResponse(response);  
  }

  
  async apiPostWithAccessToken(url,accessToken,data ={}) {
    const headers = { 
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + accessToken,
      },
      origin: this.framework.getMemorySystem().getOrigin(),
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
    };    
    const response = await axios.post(url,data,headers)
    .catch(error => {
      throw this.manageError(error);
    });
    return await this.manageResponse(response);
  } 

  async apiAuthenticatePost(url,data ={}) {
    const headers = { 
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      origin: this.framework.getMemorySystem().getOrigin(),
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
    };
    const response = await axios.post(url,data,headers)
    .catch(error => {
      throw this.manageError(error);
    });
    return await this.manageAuthenticateResponse(response);
  }    

  async fetchSystemLanguage(systemLanguageId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemLanguage?systemLanguageId='+systemLanguageId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemLanguageArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemLanguageArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemLanguage(systemLanguage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemLanguage';    
    return this.apiPostWithAccessToken(url,accessToken,systemLanguage);
  }

  async updateSystemLanguage(systemLanguage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemLanguage';    
    return this.apiPostWithAccessToken(url,accessToken,systemLanguage);
  }

  async deleteSystemLanguage(systemLanguage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemLanguage';    
    return this.apiPostWithAccessToken(url,accessToken,systemLanguage);
  }

  async fetchSystemParameter(systemParameterId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemParameter?systemParameterId='+systemParameterId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemParameterArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemParameterArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemParameter(systemParameter,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemParameter';    
    return this.apiPostWithAccessToken(url,accessToken,systemParameter);
  }

  async updateSystemParameter(systemParameter,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemParameter';    
    return this.apiPostWithAccessToken(url,accessToken,systemParameter);
  }

  async deleteSystemParameter(systemParameter,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemParameter';    
    return this.apiPostWithAccessToken(url,accessToken,systemParameter);
  }

  async fetchSystemSequence(parameterId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemSequence?parameterId='+parameterId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemSequenceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemSequenceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemSequence(systemSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemSequence';    
    return this.apiPostWithAccessToken(url,accessToken,systemSequence);
  }

  async updateSystemSequence(systemSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemSequence';    
    return this.apiPostWithAccessToken(url,accessToken,systemSequence);
  }

  async deleteSystemSequence(systemSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemSequence';    
    return this.apiPostWithAccessToken(url,accessToken,systemSequence);
  }


  async fetchSystemTextElement(systemTextElementId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemTextElement?systemTextElementId='+systemTextElementId;
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemTextElementArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemTextElementArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemTextElement(systemTextElement,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemTextElement';    
    return this.apiPostWithAccessToken(url,accessToken,systemTextElement);
  }

  async updateSystemTextElement(systemTextElement,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemTextElement';    
    return this.apiPostWithAccessToken(url,accessToken,systemTextElement);
  }

  async deleteSystemTextElement(systemTextElement,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemTextElement';    
    return this.apiPostWithAccessToken(url,accessToken,systemTextElement);
  }

  async fetchSystemUser(systemUserId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemUser?systemUserId='+systemUserId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemUserArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemUserArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemUser(systemUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemUser';    
    return this.apiPostWithAccessToken(url,accessToken,systemUser);
  }

  async updateSystemUser(systemUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemUser';    
    return this.apiPostWithAccessToken(url,accessToken,systemUser);
  }

  async deleteSystemUser(systemUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemUser';    
    return this.apiPostWithAccessToken(url,accessToken,systemUser);
  }

  async fetchSystemUserType(systemUserTypeId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemUserType?systemUserTypeId='+systemUserTypeId;
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemUserTypeArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemUserTypeArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemUserType(systemUserType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemUserType';    
    return this.apiPostWithAccessToken(url,accessToken,systemUserType);
  }

  async updateSystemUserType(systemUserType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemUserType';    
    return this.apiPostWithAccessToken(url,accessToken,systemUserType);
  }

  async deleteSystemUserType(systemUserType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemUserType';    
    return this.apiPostWithAccessToken(url,accessToken,systemUserType);
  }

  async fetchSystemUserTypePrivilege(systemUserTypePrivilegeId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemUserTypePrivilege?systemUserTypePrivilegeId='+systemUserTypePrivilegeId;
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSystemUserTypePrivilegeArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSystemUserTypePrivilegeArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSystemUserTypePrivilege(systemUserTypePrivilege,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSystemUserTypePrivilege';    
    return this.apiPostWithAccessToken(url,accessToken,systemUserTypePrivilege);
  }

  async updateSystemUserTypePrivilege(systemUserTypePrivilege,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSystemUserTypePrivilege';    
    return this.apiPostWithAccessToken(url,accessToken,systemUserTypePrivilege);
  }

  async deleteSystemUserTypePrivilege(systemUserTypePrivilege,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSystemUserTypePrivilege';    
    return this.apiPostWithAccessToken(url,accessToken,systemUserTypePrivilege);
  }
}

export default TigerSharkRestSystem;